export default __webpack_public_path__ + "b336330425d4ccb46f6cb7f6b1ceb3c6.png";